import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

export default function DevicesDonut({ onboarded, assigned, total }) {
  const data = [
    { name: 'Onboarded', value: onboarded, color: '#135FC9', gradient: 'url(#onbGradient)' },
    { name: 'Assigned', value: assigned, color: '#D6E3FF', gradient: 'url(#asGradient)' }
  ];

  // --- Tooltip bubble ---
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: '#fff',
            padding: '6px 10px',
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 700,
            color: payload[0].payload.color,
            boxShadow: '0px 2px 6px rgba(0,0,0,0.15)'
          }}
        >
          {payload[0].value}
        </div>
      );
    }
    return null;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'inline-block',
          px: 2.5,
          py: 1,
          borderRadius: 1,
          mb: 0.8,
          backgroundColor: '#F6F9FF',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '14px' }}>
          Device Stats
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 110,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <defs>
              <linearGradient id="onbGradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#73A7FF" />
                <stop offset="100%" stopColor="#135FC9" />
              </linearGradient>

              <linearGradient id="asGradient" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#D6E3FF" />
                <stop offset="100%" stopColor="#D6E3FF" />
              </linearGradient>
            </defs>
            <Tooltip content={<CustomTooltip />} cursor={false} />

            <Pie data={data} innerRadius={40} outerRadius={52} dataKey="value" nameKey="name">
              {data.map((entry, idx) => (
                <Cell key={idx} fill={entry.gradient} />
              ))}

              <Label
                position="center"
                content={() => (
                  <text
                    x="50%"
                    y="42%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{
                      fontSize: '25px',
                      fontWeight: 700,
                      fill: '#171D40',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {total}

                    <tspan
                      x="50%"
                      dy="22"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Total
                    </tspan>

                    <tspan
                      x="50%"
                      dy="10"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Devices
                    </tspan>
                  </text>
                )}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
      {/* Legend */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          columnGap: 0,
          mt: 1
        }}
      >
        {data.map((item, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <svg width="5" height="5" viewBox="0 0 8 8">
              <circle cx="4" cy="4" r="4" fill={item.color} />
            </svg>

            <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#171D40' }}>
              {item.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
